#product-type-grid{position:relative}.load-all-btn{background:#fff;color:#386aa1;border:1px solid #386aa1;margin-bottom:3px}.load-all-btn:hover,.load-all-btn:active{background:#386aa1;color:#fff}
/*# sourceMappingURL=categories.component-PFI7B73J.css.map */
